<template>
  <el-select v-model="value" placeholder="请选择" @change="changeValue($event)" :disabled="isDisabled">
    <el-option value="" label="请选择" />
    <el-option
      v-for="item in auxiliaryUnitData"
      :key="item.code"
      :label="item.name"
      :value="item.code"
    />
  </el-select>
</template>
<script>
export default {
  props: {
    isDisabled: false
  },
  data() {
    return {
      value: '',
      auxiliaryUnitData: [],
      dictType: {
        types: 'queryAuxiliaryUnitCode'
      }
    }
  },
  methods: {
    changeValue(e) {
      this.$emit('queryAuxiliaryUnitCode', this.value)
    },
    setSelectValue(value) {
      this.value = value
    },
    initDict(dictData) {
      this.auxiliaryUnitData = dictData
    }
  }
}
</script>
